














































import {Vue, Component} from 'vue-property-decorator';
import ArrowDownIcon from '@/components/icons/ArrowDown.vue';
import gsap from 'gsap';

@Component({
    name: 'AppHeader',
    components: {ArrowDownIcon},
})
export default class AppHeader extends Vue {
    public title: string = ``;
    public blinkerShow: boolean = false;
    public blinkerToggle: boolean = false;
    public rotateTitle: boolean = false;
    private titleForTimeout = `JavaScript Developer (Vue | React | Angular)`;

    public titleTimeoutSet() {
        let index: number = 0;

        const interval = setInterval(() => {
            this.title += this.titleForTimeout[index];
            index++;

            if (index >= this.titleForTimeout.length) {
                clearInterval(interval);
                this.blinkerShow = true;
                this.rotateTitle = true;
                this.startBlinkerToggle();
            }
        }, 85);
    }

    private animateHeaderDom() {
        const tl = gsap.timeline({repeat: -1, repeatDelay: 0});

        tl.to('.gsap-arrow', {y: 0, duration: 1});
        tl.to('.gsap-arrow', {y: 50, duration: 1});
        tl.to('.gsap-arrow', {y: 0, duration: 1});
    }

    private startBlinkerToggle() {
        setInterval(() => {
            this.blinkerToggle = !this.blinkerToggle;
        }, 350);
    }

    private mounted(): void {
        setTimeout(() => {
            this.titleTimeoutSet();
        }, 1000);
        this.animateHeaderDom();
    }
}
